"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var WindowApi_1 = require("@/api/browser/WindowApi");
function FeaturedMenu(props) {
    var currentLang = props.lang;
    var popularDistricts = props.megamenu.popularDistricts;
    var popularBuildings = props.megamenu.popularBuildings;
    return (React.createElement("div", { className: "c-mm-featured" },
        React.createElement("div", { className: "c-mm-column" },
            React.createElement("div", { className: "c-mm-header" },
                React.createElement("i", { className: "far fa-map-marker-alt" }),
                React.createElement("div", null, props.tMegamenu.popularDistrict)),
            React.createElement("div", { className: "c-mm-grid" }, popularDistricts.slice(0, 10).map(function (district) { return (React.createElement("a", { href: WindowApi_1.toAbsoluteUrl(district.url), className: "c-mm-item" },
                React.createElement("span", { title: district.name }, district.name))); })),
            React.createElement("a", { href: WindowApi_1.toAbsoluteUrl("/" + currentLang + "/guides/hong-kong-island"), className: "c-mm-view-all" },
                React.createElement("span", null, props.tMegamenu.viewAllDistricts),
                React.createElement("i", { className: "far fa-arrow-right" }))),
        React.createElement("div", { className: "c-mm-column" },
            React.createElement("div", { className: "c-mm-header" },
                React.createElement("i", { className: "fal fa-building" }),
                React.createElement("div", null, props.tMegamenu.popularBuilding)),
            React.createElement("div", { className: "c-mm-grid" }, popularBuildings.slice(0, 10).map(function (building) { return (React.createElement("a", { href: WindowApi_1.toAbsoluteUrl(building.url), className: "c-mm-item" },
                React.createElement("span", { title: building.name }, building.name))); }))),
        React.createElement("div", { className: "c-mm-column" },
            React.createElement("div", { className: "c-mm-header" },
                React.createElement("i", { className: "far fa-home" }),
                React.createElement("div", null, props.tMegamenu.buildingLayout)),
            React.createElement("div", { className: "c-mm-grid", style: { gridTemplateColumns: "repeat(2, fit-content(150px))" } }, props.megamenu.buildingLayouts.map(function (layout) { return (React.createElement("a", { href: WindowApi_1.toAbsoluteUrl(layout.url), className: "c-mm-item" },
                React.createElement("span", { title: layout.name }, layout.name))); })))));
}
exports.default = FeaturedMenu;
